'use client';

import FloatingContainer from '@/components/base/floating/floating-container';
import useCommonFloating from '@/components/base/floating/use-common-floating';
import { type Placement, useHover, useInteractions } from '@floating-ui/react';
import { type ReactNode, useState } from 'react';

interface Props {
  placement?: Placement;
  children?: ReactNode;
  Content?: ReactNode;
  offset?: number;
  enabled?: boolean;
  className?: string;
}

const Tooltip = ({
  placement,
  children,
  className,
  Content,
  enabled = true,
  offset = 5,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const { refs, transitionRef, context, mounted, ...containerProps } =
    useCommonFloating({
      placement,
      offset,
      isOpen,
      setIsOpen,
    });

  const { getReferenceProps, getFloatingProps } = useInteractions([
    useHover(context, { enabled }),
  ]);

  return (
    <>
      <span
        ref={refs.setReference}
        className={className}
        {...getReferenceProps()}
      >
        {children}
      </span>
      {mounted && (
        <FloatingContainer
          className="p-xs"
          ref={refs.setFloating}
          transitionRef={transitionRef}
          variant="dark"
          context={context}
          {...containerProps}
          {...getFloatingProps()}
        >
          {Content}
        </FloatingContainer>
      )}
    </>
  );
};

export default Tooltip;
